import { userDBStores } from '../schemas';
import Dexie from 'dexie';
import {
  pendingQueueStores,
  unSyncedStores,
} from '../schemas/pendingQueueSchema';

let databaseInstances: {
  [key: string]: Dexie;
} = {};

export enum GlobalDatabases {
  // UI = 'UI',
  UnSynced = 'UnSynced', // TODO: Remove this db
  PendingQueue = 'PendingQueue',
  User = 'User',
}

const openDatabase = async (name: string, dbType: GlobalDatabases) => {
  // const schema: WindowDBSchema
  let db;
  db = new Dexie(name);
  let stores = {};
  switch (dbType) {
    case GlobalDatabases.User:
      stores = userDBStores;
      break;
    case GlobalDatabases.UnSynced:
      stores = unSyncedStores;
      break;
    case GlobalDatabases.PendingQueue:
      stores = pendingQueueStores;
  }
  db.version(1).stores(stores);
  await db.open();
  databaseInstances[name] = db;
};

export async function getGlobalDatabaseInstance(
  dbName: string,
  dbType: GlobalDatabases
): Promise<Dexie> {
  if (!databaseInstances[dbName]) {
    await openDatabase(dbName, dbType);
  }
  return databaseInstances[dbName];
}

export const closeGlobalDBs = () => {
  for (let dbId in databaseInstances) {
    console.log('dbId', dbId);
    const db: Dexie = databaseInstances[dbId];
    delete databaseInstances[dbId];
    if (db) db.close();
  }
};
